<template>
  <div am-allowed-params-modal-item class="_display:flex _flex-wrap:wrap">
    <div
      v-for="value in data.values"
      :key="value.name"
      class="_margin-right:1"
    >
      <p class="_margin:0">
        {{ value.display_name }}
      </p>
      <i-checkbox-group
        v-model="val[value.name].selected"
      >
        <i-checkbox
          v-for="(facing, index) in val[value.name].possible"
          :key="index"
          :value="index"
          class="_margin-y:1/2 _border-color:light"
          size="sm"
          @change="setChangedParts(value.name)"
        >
          <p>{{ index}} ({{ facing }})</p>
        </i-checkbox>
      </i-checkbox-group>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'AllowedparamsItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isEdit: false
  }),
  computed: {
    val () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    setChangedParts (key) {
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data, tag: key })
    }
  }
}
</script>

<style lang="scss">
[am-allowed-params-modal-item] {
  .checkbox {
    cursor: default;
    .checkbox-label {
      overflow: hidden;
      cursor: pointer;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0;
      }
      &::before {
        min-width: var(----size);
        border-color: var(----border-color--checked);
      }
    }
  }
}
</style>
